// extracted by mini-css-extract-plugin
module.exports = {"declaration":"_6YcdBoC13ozoAi0ngWoVpw==","footer":"SRgIGNuNi1KPJX2Zv7Bzzw=="};